import { Node, mergeAttributes, nodeInputRule } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import ImageComponent from './ImageComponent';

const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

const Image = Node.create({
    name: 'image',
    addOptions() {
        return {
            inline: true,
            HTMLAttributes: {},
        };
    },
    inline() {
        return this.options.inline;
    },
    group() {
        return 'inline';
    },
    draggable: true,
    addAttributes() {
        return {
            file: {
                default: null,
            },
            width: {
                default: null,
            },
            height: {
                default: null,
            },
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
            title: {
                default: null,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'img[src]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'img',
            mergeAttributes(
                {
                    src: this.options.HTMLAttributes.src,
                    alt: this.options.HTMLAttributes.alt,
                    title: this.options.HTMLAttributes.title,
                    width: this.options.HTMLAttributes.width,
                    height: this.options.HTMLAttributes.height,
                },
                {
                    src: HTMLAttributes.src,
                    alt: HTMLAttributes.alt,
                    title: HTMLAttributes.title,
                    width: HTMLAttributes.width,
                    height: HTMLAttributes.height,
                },
            ),
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(ImageComponent);
    },
    addCommands() {
        return {
            setImage:
                (options) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: options,
                    });
                },
        };
    },
    addInputRules() {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: (match) => {
                    const [, , alt, src, title, width, height] = match;
                    return { src, alt, title, width, height };
                },
            }),
        ];
    },
});

export { Image, Image as default, inputRegex };
